import React from 'react';

import GuestLayout from '../../components/Layouts/GuestLayout';
import Verify from '../../components/Verify';

const VerifyPage = props => (
  <GuestLayout>
    <Verify {...props} type="signUp" />
  </GuestLayout>
);

export default VerifyPage;
